import React, { useEffect, useState } from "react";
import { Button, Checkbox, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { EyeFilled } from "@ant-design/icons";
import "../../../css/common.css";
import { post } from "../../../../services/services.js";
import { ApiURL } from "../../../../services/apiConstants.js";

const ListBunkerDeliveryCom = () => {
  const navigate = useNavigate();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [ship_id, set_ship_id] = useState("");
  const [ship_table_list, set_ship_table_list] = useState([]);

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  const SHIP_LIST_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_ship_table_list(res?.ships);
          set_ship_id(res?.ships[0]?.id);
          LIST_BUNKER_DELIVERY_NOTE(res?.ships[0]?.id);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
    }
  };

  const LIST_BUNKER_DELIVERY_NOTE = (ship_id) => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_id);
      post(ApiURL.list_bunker_delivery_bdn_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const reversedData = res?.response_data;
          setFilteredData(reversedData);
        }
        set_page_loader(false);
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "record_id",
      align: "center",
      key: "record_id",
      sorter: (a, b) => a.id - b.id,
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.id}
        </span>
      ),
    },
    {
      title: "Bunker Date",
      dataIndex: "bunker_date",
      align: "center",
      key: "bunker_date",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.bunker_date}
        </span>
      ),
    },
    {
      title: "Bdn Ref. No.",
      dataIndex: "bdn_ref_no",
      align: "center",
      key: "bdn_ref_no",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.bdn_ref_no}
        </span>
      ),
    },
    {
      title: "Bunker Ref No.",
      dataIndex: "bunker_ref_no",
      align: "center",
      key: "bunker_ref_no",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.bunker_ref_no}
        </span>
      ),
    },
    {
      title: "Sample Origin",
      dataIndex: "sample_origin",
      align: "center",
      key: "sample_origin",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.sample_origin}
        </span>
      ),
    },
    {
      title: "Marpol Seal No",
      dataIndex: "bdn_ref_no",
      align: "center",
      key: "bdn_ref_no",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.bdn_ref_no}
        </span>
      ),
    },
    {
      title: "Lop Issued",
      dataIndex: "lop_issued",
      align: "center",
      key: "lop_issued",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.lop_issued == true ? "True" : "False"}
        </span>
      ),
    },
    {
      title: "Lop copy to",
      dataIndex: "lop_copy_to",
      align: "center",
      key: "lop_copy_to",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.lop_copy_to}
        </span>
      ),
    },
    {
      title: (
        <Tooltip title={"No selections"}>
          <div style={{ textAlign: "center" }}>
            <span>Confirmed by Chief Engineer</span>
            <Checkbox
              style={{ marginLeft: 8 }}
              checked={
                filteredData.length > 0 &&
                filteredData.every((item) => item.confirm_by_chiefEngneer)
              }
              indeterminate={
                filteredData.some((item) => item.confirm_by_chiefEngneer) &&
                !filteredData.every((item) => item.confirm_by_chiefEngneer)
              }
              disabled
            />
          </div>
        </Tooltip>
      ),
      dataIndex: "updated_at",
      align: "center",
      key: "chief_review",
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Checkbox checked={record.confirm_by_chiefEngneer} disabled />
          <span
            style={{
              marginLeft: 8,
              textDecoration: record?.soft_delete ? "line-through" : "none",
            }}
          >
            Confirmed by Chief Engineer
          </span>
        </div>
      ),
    },

    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <Tooltip title="View">
          <Button
            type="primary"
            size="small"
            onClick={() => navigate(`/view-bunker-delivery-note-com/${btoa(record?.id)}`)}
            icon={<EyeFilled />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-3">
          <label className="block-label">Select Ship</label>
          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            onChange={(value) => {
              set_ship_id(value);
              LIST_BUNKER_DELIVERY_NOTE(value);
            }}
          >
            {ship_table_list?.length > 0 && (
              <>
                {ship_table_list.map((ship) => (
                  <>
                    {!ship.soft_delete && (
                      <>
                        <Select.Option key={ship.id} value={ship.id}>
                          {ship.vessel_name}
                        </Select.Option>
                      </>
                    )}
                  </>
                ))}
              </>
            )}
          </Select>
        </div>
      </div>
      <div className="row" style={{ padding: "10px" }}>
        <div className="col-6" style={{ marginLeft: "5px", alignSelf: "end" }}>
          <div className="theme-content-title text-left">
            <h3>Bunker delivery note (BDN) Information</h3>
          </div>
        </div>
        <div className="col-3"></div>
        <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="d-flex align-items-center">
            <Button
              type="primary"
              className="save_btn"
              onClick={() => navigate("/audit-trail-bunker-delivery-note-com")}
            >
              Audit Trail
            </Button>
          </div>
        </div>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        loading={page_loader}
        className="custom-table"
      />
    </>
  );
};

export default ListBunkerDeliveryCom;
